import { connect } from 'react-redux';

import { destroy, getFormValues } from 'redux-form';

import EmergencyServicesComponent from './EmergencyServicesComponent';

import { formatSelect } from '../Forms/utils';
import { getReasonOptions, openAccessPointForEmergency } from './utils';

const form = 'EmergencyServices';

const mapStateToProps = (state, ownProps) => {
  const reasonOptions = formatSelect(getReasonOptions());
  const [police] = reasonOptions;
  const initialValues = {
    reason: police?.value,
  };
  const emergencyServiceNote = ownProps?.building?.emergencyServiceNote;
  const formValues = getFormValues(form)(state);

  return {
    form,
    initialValues,
    reasonOptions,
    emergencyServiceNote,
    reason: formValues?.reason,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: async (data) => {
    const { reason: title, comment } = data;
    const { accessPoint, setIsEmergencyServicesShown } = ownProps;
    const reason = `${title}${comment ? ` - ${comment}` : ``}`;
    await openAccessPointForEmergency(dispatch, accessPoint, { reason });
    setIsEmergencyServicesShown(false);
    dispatch(destroy(form));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmergencyServicesComponent);
